import ContactForm from "../ui/Forms/contactForm";
import { Container, ProfileContainer, Row } from "../ui/Containers";
import profile from "../../assets/images/johnwandera.png";
import "../../App.css";
import { styled } from "styled-components";
import useMediaQuery from "../../hooks/useMediaQuerryHook";
import { SocialIcons } from "../ui/Icons";
import { useTheme } from "../../context/ThemeContext";
import ParticleBackground from "../ui/EngineParticles";
import { useState } from "react";
import Parallax from "../ui/Parallax";
import PageTransition from "../../utils/TransitionPage";
import { useLoader } from "../../hooks/useLoader";
import { useAuth } from "../../context/AuthContext";
import { ShowAlertProps } from "../common/types";

const AlignContactDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;

  // @media (max-width: 576px) {
  //   // margin: 2.5rem 0 0 0;
  // }
  position: relative;
  // border: 1px solid black;
`;

const ElevateText = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0 0 3rem 0;
  text-align: center;
  @media (max-width: 576px) {
    margin: 5rem 0 2rem 0;
  }
`;

const Right = styled.div`
  margin-left: 3rem;
`;

function LargeArrangement({ showAlert, showLoader }: ShowAlertProps) {
  const { theme } = useTheme();
  return (
    <>
      <div className="d-flex flex-row flex-wrap justify-content-center">
        <ContactForm showAlert={showAlert} showLoader={showLoader}/>

        <Right>
          <ProfileContainer
            $imageUrl={profile}
            $imgSize="160px"
            $circleBgSize="200px"
            //  for the bubble hover
            $bubbleSize="200px"
            $sizeOuterCircle="60px"
            $marginTopAndLeft="-30px"
            $marginTopAndLeftHover="-100px"
            $sizeOuterCircleHover="200px"
            $fontSize="10px"
            $fontSizeHover="12px"
            $letterSpacingHover="5.5px"
          />
          <SocialIcons isDarkMode={theme === "dark"} />
        </Right>
      </div>
    </>
  );
}
function SmallArrangement({ showAlert, showLoader }: ShowAlertProps) {
  const { theme } = useTheme();
  return (
    <>
      <div className="d-flex flex-row flex-wrap justify-content-center">
        <ProfileContainer
          $imageUrl={profile}
          $imgSize="160px"
          $circleBgSize="200px"
          //  for the bubble hover
          $bubbleSize="200px"
          $sizeOuterCircle="60px"
          $marginTopAndLeft="-30px"
          $marginTopAndLeftHover="-100px"
          $sizeOuterCircleHover="200px"
          $fontSize="10px"
          $fontSizeHover="12px"
          $letterSpacingHover="5.5px"
        />
        <ContactForm showAlert={showAlert} showLoader={showLoader} />
        <SocialIcons isDarkMode={theme === "dark"} />
      </div>
    </>
  );
}

function Contact() {
  const isTabletMode = useMediaQuery(768);
  const [showTransition, setShowTransition] = useState(true);
    const { setShowLoader, LoaderComponent } = useLoader();
    const { showAlert } = useAuth();

  return (
    <>
      {showTransition && (
        <PageTransition onFinish={() => setShowTransition(false)} />
      )}

      {!showTransition && (
        <Container>
          <Row>
            <AlignContactDiv className="App-col">
              <ParticleBackground />
              <Parallax offset={25}>
                <ElevateText>Let's Elevate Your Idea—Together</ElevateText>
              </Parallax>
              <Parallax offset={15}>
                <div style={{ zIndex: 1 }}>
                  {isTabletMode ? <SmallArrangement    showLoader={setShowLoader}
                      showAlert={showAlert} /> : <LargeArrangement    showLoader={setShowLoader}
                      showAlert={showAlert} />}
                </div>
              </Parallax>
            </AlignContactDiv>
          </Row>
        </Container>
      )}

       {/* Call loader */}
      {LoaderComponent}
    </>
  );
}

export default Contact;
